import { useState } from 'react'

import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { MediaFileClient } from 'api/clients/MediaFileClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { AlmanacFile } from 'types'

export const useConfirmDeleteMediaFile = (file: AlmanacFile) => {
  const workspace = useCurrentWorkspace()
  const [isProcessing, setIsProcessing] = useState(false)

  const onConfirm = async () => {
    if (!workspace?.id || !file?.media_file_id) return

    setIsProcessing(true)
    const res = await MediaFileClient.destroy(workspace.id, file.media_file_id)

    if (res.type === 'error') {
      if (res.status === 403) {
        showToastMessage('You do not have permission to delete this file', 'error')
        return false
      }

      showToastMessage('We were unable to delete your file', 'error')
      return false
    }

    showToastMessage(`${file.title} was deleted`)

    return true
  }

  return { onConfirm, isProcessing }
}
